import { UserRole } from '../components/actions/ActionsPanel';

// User persona interface
export interface UserPersona {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  avatar: string;
  title: string;
  description: string;
}

// Define our three personas based on the avatar filenames
export const personas: UserPersona[] = [
  {
    id: 'executive',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@examplecu.com',
    role: 'CEO',
    avatar: '/avatars/sarah_johnson_ceo.png',
    title: 'Chief Executive Officer',
    description: 'Strategic oversight of bank operations'
  },
  {
    id: 'lending-vp',
    name: 'Michael Chen',
    email: 'michael.chen@examplecu.com',
    role: 'VP of Lending',
    avatar: '/avatars/michael_chen_vp.png',
    title: 'VP of Lending',
    description: 'Manages lending portfolio and policy'
  },
  {
    id: 'loan-advisor',
    name: 'Jessica Williams',
    email: 'jessica.williams@examplecu.com',
    role: 'Loan Advisor',
    avatar: '/avatars/jessica_williams_LA.png',
    title: 'Senior Loan Advisor',
    description: 'Helps members with financial decisions'
  }
];

// Map of which roles each persona can access in the ActionIQ panel
export const accessibleRoles: Record<UserRole, UserRole[]> = {
  'CEO': ['CEO'], // CEO can only access Executive view
  'VP of Lending': ['VP of Lending'], // VP of Lending can only access Lending VP view
  'Loan Advisor': ['Loan Advisor'] // Loan Advisor can only access Loan Advisor view
};

// Map of which ActionIQ views each role can access
export const roleAccessMap = {
  'CEO': ['executive-dashboard', 'strategic-initiatives'],
  'VP of Lending': ['portfolio-performance', 'lending-analytics', 'risk-management'],
  'Loan Advisor': ['member-opportunities', 'lending-products', 'member-outreach']
};

// Check if a persona can access a specific role
export const canAccessRole = (currentRole: UserRole, targetRole: UserRole): boolean => {
  const allowedRoles = accessibleRoles[currentRole] || [];
  return allowedRoles.includes(targetRole);
};

// Check if a persona can access a specific view
export const canAccessView = (role: UserRole, viewId: string): boolean => {
  const allowedViews = roleAccessMap[role] || [];
  return allowedViews.includes(viewId);
};

// Get a single persona by ID
export const getPersonaById = (id: string): UserPersona | undefined => {
  return personas.find(persona => persona.id === id);
};

// Get a single persona by role
export const getPersonaByRole = (role: UserRole): UserPersona | undefined => {
  return personas.find(persona => persona.role === role);
};

// Get all available personas
export const getAllPersonas = (): UserPersona[] => {
  return [...personas];
}; 